export default (props, vars) => vars?.['useform2']?.['formState'].isSubmitting;
